// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes _colors-export-module-spin-3FoK\\+{0%{transform:rotate(0deg)}100%{transform:rotate(360deg)}}", "",{"version":3,"sources":["webpack://./src/scss/mixins/button/button-state.scss"],"names":[],"mappings":"AAkCA,6CACE,GACE,sBAAA,CAGF,KACE,wBAAA,CAAA","sourcesContent":["@mixin button-loading($loaderColor: c(base, white-color)) {\n  $_loader-size: 1em;\n\n  color: transparent;\n  pointer-events: none;\n  position: relative;\n\n  &::after {\n    animation: spin 750ms linear infinite;\n    border: 0.2rem solid $loaderColor;\n    border-radius: 50%;\n    border-top-color: transparent;\n    content: '';\n    height: $_loader-size;\n    left: 50%;\n    margin: -0.5 * $_loader-size 0 0 -0.5 * $_loader-size;\n    position: absolute;\n    top: 50%;\n    width: $_loader-size;\n  }\n}\n\n@mixin button-disabled {\n  &:not(.loading) {\n    color: c(brand, tertiary500);\n  }\n\n  pointer-events: none;\n}\n\n@mixin button-fluid {\n  width: 100%;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"primary100": "#e8eeff",
	"primary200": "#cbddfd",
	"primary300": "#91c0f3",
	"primary400": "#4c9ddc",
	"primary500": "#2a8abf",
	"primary600": "#2163a0",
	"primary700": "#184f81",
	"primary800": "#174174",
	"primary900": "#022a3f",
	"secondary100": "#e8f3ff",
	"secondary200": "#9bdbff",
	"secondary300": "#59d2ff",
	"secondary400": "#3cf",
	"secondary500": "#2ab1dc",
	"secondary600": "#2196b9",
	"secondary700": "#197a95",
	"secondary800": "#125e72",
	"secondary900": "#013542",
	"tertiary100": "#f8fafc",
	"tertiary200": "#e8ecee",
	"tertiary300": "#dce1e4",
	"tertiary400": "#d1d7db",
	"tertiary500": "#b5bec5",
	"tertiary600": "#7d8f9b",
	"tertiary700": "#576670",
	"tertiary800": "#47535c",
	"tertiary900": "#313940",
	"tertiary1000": "#141d24",
	"success100": "#ecf6f3",
	"success200": "#d7e8e2",
	"success300": "#c3e2d8",
	"success400": "#add7c9",
	"success500": "#6ab49b",
	"success600": "#278e6c",
	"success700": "#187254",
	"success800": "#185843",
	"success900": "#072c1f",
	"warning100": "#fff9ee",
	"warning200": "#fff0d4",
	"warning300": "#ffe3af",
	"warning400": "#ffda95",
	"warning500": "#ffca50",
	"warning600": "#fba700",
	"warning700": "#bb5a01",
	"warning800": "#582f18",
	"warning900": "#2c1907",
	"error100": "#ffe8e8",
	"error200": "#ffd5d5",
	"error300": "#ff8e8e",
	"error400": "#eb3a47",
	"error500": "#c03",
	"error600": "#ac0029",
	"error700": "#8a001f",
	"error800": "#680016",
	"error900": "#36000b",
	"white-color": "#fff",
	"black-color": "#000",
	"research-bg-color": "#dfe9f1",
	"research-font-color": "#346b98",
	"news-bg-color": "#efe1e9",
	"news-font-color": "#947",
	"covenants-bg-color": "#ddebec",
	"covenants-font-color": "#24727b",
	"financials-bg-color": "#daefd5",
	"financials-font-color": "#3b762e",
	"risk-products-bg-color": "#e0d7ed",
	"risk-products-font-color": "#49306b",
	"docket-keycase-bg-color": "#dfe9f1",
	"docket-keycase-font-color": "#346b98",
	"changes-green-color": "#a0d4d3",
	"changes-yellow-color": "#ffd28a",
	"changes-red-color": "#f7b0b0",
	"changes-grey-color": "#d5dbdf",
	"changesUp": "#278e6c",
	"changesDown": "#c9243a",
	"changesNew": "#174174",
	"content": "#585858",
	"high100": "#d33f52",
	"high50": "#f59d9d",
	"moderate": "#b5bec5",
	"low50": "#91c0f3",
	"low100": "#2b6bb1",
	"not-available": "#dec365",
	"unrated": "#5bb5bd",
	"cat-high100": "#d33f52",
	"cat-high50": "#f59d9d",
	"cat-moderate": "#b5bec5",
	"cat-low50": "#91c0f3",
	"cat-low100": "#2b6bb1",
	"cat100": "#6d5989",
	"cat200": "#6191b9",
	"cat300": "#dec365",
	"cat400": "#6ea961",
	"cat500": "#b5bec5",
	"cat600": "#ad6992",
	"cat700": "#2e5482",
	"cat800": "#5bb5bd",
	"4%": "rgba(26,26,26,.04)",
	"8%": "rgba(26,26,26,.08)",
	"12%": "rgba(26,26,26,.12)",
	"16%": "rgba(26,26,26,.16)",
	"24%": "rgba(26,26,26,.24)",
	"32%": "rgba(26,26,26,.32)",
	"spin": "_colors-export-module-spin-3FoK+"
};
export default ___CSS_LOADER_EXPORT___;
